import { CombinedFilmObject } from "../types/dataTypes";

export function capitaliseFirstLetterOfString(str: string): string {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function normaliseUpperCaseFilmTitle(str: string): string {
  if (!str) return "";
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function createListOfAllVenuesForIndividualPopularFilmPage(
  normalisedFilmTitle: string,
  film: CombinedFilmObject,
  maxVenuesInList: number = 5,
): string {
  const venues = Array.from(
    new Set(
      film.screenings_data.flatMap((day) =>
        day.screenings.map((s) => s.venue_name.trim()).filter(Boolean),
      ),
    ),
  );

  const limitedVenues = venues.slice(0, Math.max(0, maxVenuesInList));
  const remainingCount = venues.length - limitedVenues.length;

  const list =
    limitedVenues.length === 0
      ? ""
      : limitedVenues.length === 1
        ? limitedVenues[0]
        : limitedVenues.length === 2
          ? `${limitedVenues[0]} and ${limitedVenues[1]}`
          : `${limitedVenues.slice(0, -1).join(", ")}, and ${limitedVenues[limitedVenues.length - 1]}`;

  const suffix =
    remainingCount > 0
      ? ` (plus ${remainingCount} others venue${remainingCount === 1 ? "" : "s"}).`
      : ".";

  return `View screenings of ${normalisedFilmTitle} at ${list}${suffix}`;
}
